module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_6621.f1254e2d.jpg";